<template>
  <div class="form-radio">
    <FormTitle
      :required="Boolean(data.is_must_answer)"
      :title="data.title"
      :desc="data.title_details"
      style="margin-bottom: 10px"
    />
    <gkFormCustomGroup
      :field="data.id.toString()"
      :rule="isValidity ? rules : []"
      :validity="isValidity"
      v-model="value"
    >
      <template v-for="(option, i) in options">
        <div class="item" :key="i">
          <gkFormCheck
          class="my-form-radio"
          type="radio"
          color="radio"
          :value="`${option.key}${dataConcatStr}${option.title}${dataConcatStr}${data.type}`"
          :label="option.title"
          @change="handleChange(option, $event)"
          v-model="radios"/>
          <div class="other" v-if="showInput && option.type === 100202">
            <gkFormText
              :field="'radioUseless'"
              :placeholder="option.tips"
              :rule="isValidity && option.is_must_answer ? [{required: '请填写'}] : []"
              size="small"
              color="gray"
              validity
              @input="input(option, $event)"
              v-model="radiosWord"
            />
            <span class="tip" v-if="option.is_must_answer">(必填)</span>
          </div>
        </div>
      </template>
    </gkFormCustomGroup>
  </div>

</template>
<script>
import VueTypes from 'vue-types'

import gkFormCheck from 'gkui/form/FormCheck'
import gkFormCustomGroup from 'gkui/form/FormCustomGroup'
import gkFormText from 'gkui/form/FormText'
import FormTitle from '@/components/FormTitle'
import config from '@/config'

export default {
  name: 'textare-input',
  props: {
    data: VueTypes.object,
    answer: VueTypes.object,
    userFieldInfo: VueTypes.object.def({})
  },
  components: {
    gkFormCustomGroup,
    gkFormCheck,
    FormTitle,
    gkFormText
  },
  data () {
    return {
      value: '',
      radios: '',
      radiosWord: '',
      showInput: false,

      dataConcatStr: config.dataConcatStr
    }
  },
  watch: {
    userFieldInfo: {
      handler: function (newData, oldData) {
        try {
          // eslint-disable-next-line camelcase
          const extraInfo = this.data?.extra_info && JSON.parse(this.data.extra_info)
          if (!extraInfo) {
            return
          }
          const { user_attribute: key } = extraInfo
          if (newData !== oldData && key && newData[key]) {
            const value = newData?.[key]
            if (value) {
              const info = this.data.details.options.find(ele => ele.title === value[0])
              const ret = `${info.key}${this.dataConcatStr}${info.title}${this.dataConcatStr}${this.data.type}`
              this.radios = ret
              this.value = this.radios
            }
          }
        } catch (e) {
          console.log(e)
        }
      },
      immediate: true
    }
  },
  computed: {
    options () {
      return this.data.details.options
    },
    rules () {
      let rule = []
      if (this.data.is_must_answer) {
        rule.push({
          required: '请选择'
        })
      }
      return rule
    },
    isValidity () {
      return Boolean(this.data.showQuestion)
    }
  },
  created () {
  },
  methods: {
    handleChange (option, $event) {
      this.showInput = option.type === 100202
      this.value = $event
      this.$emit('judgeRule', {qId: this.data.id, qKey: option.key})
    },
    input (option, $event) {
      if ($event) {
        this.value = `${option.key}${this.dataConcatStr}${$event}${this.dataConcatStr}${this.data.type}`
      } else {
        this.value = this.radios
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/_common";

.form-radio {

  & .item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    min-height: 22px;

    &:last-child {
      padding-bottom: 0;
    }

    & .my-form-radio {
      align-items: flex-start;
      flex: none;
      max-width: 100%;
    }

    & ::v-deep {
      & .gkui-form-element[data-color="gray"] {
        min-height: 22px;

        & .gkui-form-error {
          bottom: -88%;
        }
      }

      & [gkcheck-color="radio"] {
        flex: none;
        width: 18px; height: 18px;
        margin-top: 2px;
      }

      & [gkcheck-color="radio"] + span {
        font-size: 16px; line-height: 22px;
        color: $bodyBlack;
        word-break: break-all;
      }

      & [checked="checked"] + span {
        color: $blue;
      }

      & [gkcheck-color="radio"][checked="checked"] {
        border: 1px solid $blue;
        background-color: $blue;

        & span {
          width: 7px; height: 7px;
          background-color: #fff;
          border: none; border-radius: 50%;
        }
      }
    }

    & [data-size="small"] {
      flex: 1;
      height: 22px;
      border: none; border-bottom: 1px solid $bodyBlack; border-radius: 0;
    }

    & .other {
      display: flex;
      align-items: center;
      padding-left: 7px;

      & ::v-deep .gkui-form-element {
        width: 210px;

        & .gkui-form-text {
          padding: 0 6px;
          line-height: 22px;
          color: #4a4a4a;
        }
      }

      & .tip {
        padding-left: 11px;
        @include font(16, 400);
        line-height: 22px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .form-radio .item .other ::v-deep .gkui-form-element {
    width: 100px;
  }
}
</style>
